import Types from '../types';

export default (reducerState = [], action) => {
  switch (action.type) {
    case Types.SET_COURSE_MATERIALS:
      return action.payload;
    default:
      return reducerState;
  }
};
